import BaseComponent from './BaseComponent';

class ModalTrigger extends BaseComponent {
  constructor(componentName){
    super(componentName);
  }

  init(component) {
    this.addCustomEvents(component);
  }

  addCustomEvents(component) {
    const element   = component.element;
    const modalName = element.getAttribute('data-modal-target');
    const modals    = document.getElementsByClassName('modal-wrapper');
    let modalTarget;

    // Find the proper modal
    for (let modal of modals) {
      if (modalName === modal.getAttribute('data-modal')) {
        modalTarget = modal;
        break;
      }
    }

    if(!!modalTarget) {

      // Open Modal
      element.addEventListener('click', () => {
        this.specificActionsForSomeModals(element, modalTarget);

        // Update shared modals info (modals that need to be
        // refreshed with the current product info)
        if(modalName == 'book-product' || modalName == 'email-when-stock') {
          const id = element.getAttribute('data-product-id');
          if(id) {
            console.warn('modal triggerer clicked -> updating "no stock" type modals');
            const data = app.components.product.getProductData(id);
            app.components.product.updateModals(data);
          }
        }

        // JUST FOR RESET PASSWORD MODAL
        if(modalName == 'reset-password') {
          const email = document.querySelector('input[type="email"]');
          const value = email.value
          if(!!email && value.length > 0) {
            const modalInputs = modalTarget.getElementsByTagName('input');
            for(let input of modalInputs) {
              if(input.type == 'email') {
                input.value = value;
                break;
              }
            }
          }
        }

        modalTarget.classList.add('is-active');
        app.scroller.lockScroll();
      });

      // Close Modal when button click
      const closeModalButtons = modalTarget.getElementsByClassName('close');
      for (let closeModalButton of closeModalButtons) {
        closeModalButton.addEventListener('click', (e) => {
          if(closeModalButton.getAttribute('type') == 'submit') {
            const form = modalTarget.getElementsByClassName('form')[0];
            var input = form.getElementsByClassName('add_to_cart_submit_type')[0];
            input.value = 'button';
            app.components.form.submitDataOfForm(form);
          }
          this.closeModal(modalTarget);
        });
      }

      // Close modal when backlayer click
      const backLayer = modalTarget.getElementsByClassName('back-layer')[0];
      if(!!backLayer) {
        backLayer.addEventListener('click', (e) => {
          this.closeModal(modalTarget);
        });

        backLayer.addEventListener('tap', (e) => {
          this.closeModal(modalTarget);
        });
      }

      // Close modal when user click ESC key
      element.addEventListener('keydown', (e) => {
        if (e.keyCode == 27) {
          this.closeModal(modalTarget);
        }
        return false;
      })

    }
  }

  closeModal(modalTarget) {
    if (!modalTarget.classList.contains('is-active')) return;

    modalTarget.classList.remove('is-active');
    app.scroller.unlockScroll();
  }

  openModal(modalTarget) {
    if (modalTarget.classList.contains('is-active')) return;

    modalTarget.classList.add('is-active');
    app.scroller.lockScroll();
    this.sendGaHitonVolumeDiscountsOffer(modalTarget);
  }

  specificActionsForSomeModals(triggerElement, modalTarget) {
    if(modalTarget.classList.contains('become-business-form')) {
      const email = triggerElement.previousElementSibling;
      const modalEmail = modalTarget.querySelector('input[type="email"]');
      modalEmail.value = email.value;
    }

    if (modalTarget.getAttribute('data-modal') === 'promo--advent-calendar') {
      startLottiePromo();
    }

    if (modalTarget.getAttribute('data-modal') === 'banner-progression') {
      const id = triggerElement.getAttribute('data-banner-id');
      app.components.banner.updateModalContent(id, modalTarget);
    }
  }

  sendGaHitonVolumeDiscountsOffer(modalTarget) {

    if (modalTarget.id == 'volume-modal') {
      var discountsPerVolumeWrapper = modalTarget.getElementsByClassName('discounts-per-volume-wrapper')[0];
      var SAPcode;
      if(!!discountsPerVolumeWrapper) {
        SAPcode = discountsPerVolumeWrapper.getAttribute('data-product-sap-code');
      }

      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      window.dataLayer.push({
        'event': 'Volume Discount Offered',
        'eventCategory': 'Volume Discount',
        'eventAction': 'offered',
        'eventLabel': SAPcode
      });
    }
  }

}

export default ModalTrigger;
